import { ApplicationDispatcher } from '~/flux/dispatchers';
import { logError } from '~/logger';
import { ApiErrorMessage } from 'dt-common/types/ApiErrorMessages';

const apiUrl = process.env.DT_API_ADDRESS || 'http://localhost:3001';

interface GraphQlError {
  message: string;
  locations?: { line: number; column: number; }[];
  path?: string[];
  extensions?: Record<string, unknown>; // Use this for custom error codes (e.g., "UNAUTHENTICATED")
}

export class GraphQlRequestError extends Error {
  constructor(message: string, public errors: GraphQlError[] = []) {
    super(message);
    this.name = 'GraphQlRequestError';
  }
}

const graphqlClient = {
  request: async <T>(
    operationName: string,
    query: string,
    variables: Record<string, any>
  ): Promise<T> => {
    const response = await fetch(`${apiUrl}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    const result = await response.json();

    if (result.errors) {
      if (result.errors[0].message === ApiErrorMessage.API_CALL_IS_LOCKED) {
        ApplicationDispatcher.handleAppAction({
          actionType: ApplicationDispatcher.NO_REDLOCK,
          lock_name: operationName,
        });
      }

      const errorMessages = result.errors.map((err: GraphQlError) => err.message).join('\n');
      const graphqlRequestError = new GraphQlRequestError(`GraphQL errors:\n${errorMessages}`, result.errors);
      logError(graphqlRequestError);
      throw graphqlRequestError;
    }

    const data = result.data[operationName];
    return data;
  },
};
export default graphqlClient;
